var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5674 20C16.0902 20 20.5674 15.5228 20.5674 10C20.5674 4.47715 16.0902 0 10.5674 0C5.04454 0 0.567383 4.47715 0.567383 10C0.567383 15.5228 5.04454 20 10.5674 20ZM4.56738 5.2C4.56738 4.5382 5.16538 4 5.90072 4H15.234C15.9694 4 16.5674 4.5382 16.5674 5.2V10.6C16.5674 11.2618 15.9694 11.8 15.234 11.8H12.5674V10.6H15.234V5.2L5.90072 5.2V10.6H8.56738V11.8H5.90072C5.16538 11.8 4.56738 11.2618 4.56738 10.6L4.56738 5.2ZM9.90072 13V7.6H11.234V13H13.234L10.5674 16L7.90072 13H9.90072Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.015d33519d344372da56f163cb146b63.svg";
export { ForwardRef as ReactComponent };